/**
 * 驗證相關常數
 * 統一管理驗證正則表達式和錯誤訊息
 */
/**
 * 驗證正則表達式
 */
export const REGEX = {
    /**
     * 台灣手機號碼格式：09XXXXXXXX (10 位數字，以 09 開頭)
     */
    TAIWAN_PHONE: /^09\d{8}$/,
};
/**
 * 驗證錯誤訊息
 */
export const VALIDATION_MESSAGES = {
    /**
     * 台灣手機號碼驗證錯誤訊息
     */
    TAIWAN_PHONE: '請輸入有效的台灣手機號碼（格式：09XXXXXXXX）',
};
